import { useState } from 'react';
import { BsSearch } from 'react-icons/bs';
import { Input } from 'reactstrap';

export default function SearchBox({
  onSearch,
  width = 500,
  placeholder = 'Search',
}) {
  const [query, setQuery] = useState('');

  const onChangeQuery = (val) => {
    if (val) setQuery(val);
    else {
      setQuery('');
      onSearch('');
    }
  };
  const handleEnter = (target) => {
    if (target.charCode === 13) {
      onSearch(query);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }}
    >
      <Input
        style={{ height: 35, width }}
        value={query}
        onChange={(e) => onChangeQuery(e?.target?.value)}
        placeholder={placeholder}
        onKeyPress={handleEnter}
      />
      {query && (
        <span
          onClick={() => {
            onChangeQuery('');
          }}
          style={{ position: 'relative', right: 15, cursor: 'pointer' }}
        >
          X
        </span>
      )}
      <BsSearch
        style={{
          marginLeft: 5,
          fontSize: 25,
          color: '#414141',
          cursor: 'pointer',
        }}
        onClick={() => {
          onSearch(query);
        }}
      />
    </div>
  );
}
